<template>
    <div>
        <div>
            <button class="btn btn-purple text-white mr-2" :class="getSelectedClass('field')" @click="openConditionModal">Add Condition</button>
        </div>

        <!-- Conditions List -->
        <div class="card w-50 mt-4" v-if="finalConditions.length > 0">
            <div class="card-header">
                <h6> Conditions </h6>
            </div>
            <ul class="list-group list-group-flush">
                <li class="list-group-item d-flex align-items-center" v-for="(condition, index) in finalConditions" :key="'condition' + index">
                    <div :class="[isFieldDeleted(condition) ? 'w-70' : 'w-85']">
                        If <strong class="text-capitalize"> {{ condition.triggerLabel }} </strong> is {{ condition.triggerOperator }}
                        <span v-html="formatDisplayValues(condition.triggerValueDisplays)"></span>
                    </div>
                    <div v-if="isFieldDeleted(condition)" class="w-15">
                        <span class="text-danger">(This field is deleted)</span>
                    </div>
                    <div class="w-15 text-align-end">
                        <button class="btn btn-sm btn-warning mx-1" @click="editCondition(condition, index)"> <i class="fa fa-pencil" aria-hidden="true"></i> </button>
                        <button class="btn btn-sm btn-light-red mx-1" @click="removeCondition(index)"> <i class="fa fa-trash" aria-hidden="true"></i> </button>
                    </div>
                </li>
            </ul>
        </div>

        <!-- Condition Modal -->
        <automation-condition-modal
            ref="AutomationConditionModal"
            :form="form"
            :all_codes="all_codes"
            :automation="automation"
            :allProjectFields="allProjectFields"
            :allCompanyFields="allCompanyFields"
            :allContactFields="allContactFields"
            :dropdown_options="dropdown_options"
            :dropdown_user_values="dropdown_user_values"
            :company_types="company_types"
            :contact_types="contact_types"
            :team_contact_statuses="team_contact_statuses"
        >
        </automation-condition-modal>
    </div>
</template>

<script>
import AutomationConditionModal from "./automation-conditions-modal.vue";

export default {
    name: 'AutomationConditions',
    components: {AutomationConditionModal},
    props: ['form', 'automation', 'allProjectFields', 'allCompanyFields', 'allContactFields', 'dropdown_options',
            'dropdown_user_values', 'all_codes', 'company_types', 'contact_types', 'team_contact_statuses'],
    data() {
        return {
            finalConditions: []
        }
    },
    mounted() {
        this.finalConditions = this.automation ? this.automation.automation_conditions : [];
    },
    watch: {
        finalConditions: {
            handler: function(newValue) {
                this.$parent.form.automation_conditions = this.finalConditions;
            },
            deep: true
        }
    },
    methods: {
        openConditionModal() {
            this.$refs.AutomationConditionModal.openModal();
        },
        getSelectedClass(val) {
            const self = this;

            if(self.form.automation_type === val){
                return 'selected_button'
            }
            if(self.form.automation_object === val){
                return 'selected_button'
            }
            if(self.form.automation_trigger === val){
                return 'selected_button'
            }
            if(self.form.automation_exclude_field === val){
                return 'selected_button'
            }
            if(val === 'field' && self.form.automation_field !== 'empty'){
                return 'selected_button'
            }
            if(self.form.automation_filter === val){
                return 'selected_button'
            }

            return '';
        },
        formatDisplayValues(values) {
            return values.map(value => `<strong>${value}</strong>`).join(' <small>OR</small> ');
        },
        removeCondition(key) {
            this.finalConditions.splice(key, 1);
        },
        editCondition(condition, index) {
            this.$refs.AutomationConditionModal.editCondition(condition, index);
        },
        isFieldDeleted(condition) {
            return condition?.isCustomFieldDeleted || condition?.isSalesBehaviorDeleted;
        }
    }
}
</script>

<style scoped>
.selected_button {
    border: 2px solid black;
    border-radius: 5px;
}
.btn-purple {
    background: #6e7ff2;
}
.btn-light-red {
    background: #f87676;
}
.card-header {
    background-color: rgba(0,0,0,.03);
}
.w-85 {
    width: 85%;
}
.w-70 {
    width: 70%;
}
.w-15 {
    width: 15%;
}
.text-align-end {
    text-align: end;
}
</style>
